import { FormGroup, FormControl } from "@angular/forms";
import { Constants } from "@shared/models/common/constants";

export class Search {
    searchValue: string;
    resultTypes: any = [];
    databases: any[] = [];
    author: any[] = [];
    series: any[] = [];
    yearFrom: string;
    yearTo: string;
    township: any[] = [];
    nts: any[] = [];
    residentGeologist: any;
    commodity: any[] = [];
    tempAuthor: string = "";
    tempTownship: string = "";
    tempNts: string = "";
    tempSeries: string = "";
    tempCommodity: string = "";

    constructor(init?: Partial<Search>) {
        this.resultTypes = Constants.RESULT_TYPE_OPTIONS;
        this.databases = Constants.DATABASE_TYPE_OPTIONS;
        Object.assign(this, init);
    }

    toForm() {
        return new FormGroup({
          searchValue: new FormControl(this.searchValue),
          author: new FormControl(this.author),
          series: new FormControl(this.series),
          yearFrom: new FormControl(this.yearFrom),
          yearTo: new FormControl(this.yearTo),
          township: new FormControl(this.township),
          nts: new FormControl(this.nts),
          commodity: new FormControl(this.commodity),
          resultTypes: new FormControl(this.resultTypes),
          databases: new FormControl(this.databases),
          tempAuthor: new FormControl(this.tempAuthor),
          tempTownship: new FormControl(this.tempTownship),
          tempNts: new FormControl(this.tempNts),
          tempSeries: new FormControl(this.tempSeries),
          tempCommodity: new FormControl(this.tempCommodity)
        });
      }
    
      toModel(form: FormGroup) {
        const v = form.getRawValue();
        return new Search({
            searchValue : v.searchValue,
            author: v.author,
            series: v.series,
            yearFrom: v.yearFrom,
            yearTo: v.yearTo,
            township: v.township,
            nts: v.nts,
            resultTypes: v.resultTypes,
            databases: v.databases,
            tempAuthor: v.tempAuthor,
            tempTownship: v.tempTownship,
            tempNts: v.tempNts,
            tempSeries: v.tempSeries,
            tempCommodity: v.tempCommodity
        });
      }

}